// API 配置
const API_BASE_URL = process.env.NODE_ENV === 'production' 
  ? 'https://api.snagyourtee.com'
  : 'http://localhost:3000';

export const API_ENDPOINTS = {
  getUserInfo: `${API_BASE_URL}/api/users/me`,
  getUserRequests: `${API_BASE_URL}/api/users/me/monitoring-requests`,
  cancelUserRequest: (id: number) => `${API_BASE_URL}/api/users/me/monitoring-requests/${id}`,
  getUserInviteStats: `${API_BASE_URL}/api/users/me/invite-stats`,
} as const;

export default API_BASE_URL;